export const RESOURCE_ENTRY_TYPE = 'resource';

export const OBSERVED_INITIATOR_TYPES = ['fetch', 'xmlhttprequest'] as const;

/**
 * Lower-cased `Server-Timing` metric names that represent the total backend
 * processing duration, in priority order. The first match found on a
 * `PerformanceResourceTiming` entry is subtracted from the TTFB to isolate the
 * pure network latency. Align these with whatever the backend emits, e.g.
 * `Server-Timing: total;dur=123`.
 */
export const SERVER_TIMING_PROCESSING_METRICS = [
  'total',
  'app',
  'cpu',
] as const;

/**
 * Minimum body size (bytes) for a transfer to yield a trustworthy throughput
 * estimate. Small payloads are dominated by latency/TCP slow-start rather than
 * bandwidth, so their apparent rate is meaningless and excluded.
 */
export const MIN_THROUGHPUT_SAMPLE_BYTES = 8 * 1024;
